var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Header/Search/index.js",
    _this = this;

import React from 'react';
import styled, { css } from 'styled-components';
import SearchInput from './SearchInput';
import { withTheme } from '../../../core/ThemeProvider';
import SearchIcon from './icons/searchCircleOutlineIcon.svg';
import SearchIconHover from './icons/searchCircleOutlineIconHover.svg';
var SCSearchIconContainer = withTheme(styled.div.withConfig({
  displayName: "Search__SCSearchIconContainer",
  componentId: "sc-1u9hsx0-0"
})(function (props) {
  return css(["display:flex;svg{cursor:pointer;width:", ";height:", ";&.hover{display:none;}}", ""], props.coreTheme.header.deskTopIconWidth, props.coreTheme.header.deskTopIconHeight, props.isIconHoverRequired && css(["&:hover{svg{display:none;}.hover{display:block;}}"]));
}));

var Search = function Search(_ref) {
  var _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? true : _ref$isActive,
      onSearchIconClick = _ref.onSearchIconClick,
      onSearchInputActivated = _ref.onSearchInputActivated,
      searchInputClassName = _ref.searchInputClassName,
      placeholder = _ref.placeholder,
      isIconHoverRequired = _ref.isIconHoverRequired;
  return isActive ? /*#__PURE__*/React.createElement(SearchInput, {
    onSearchIconClick: onSearchIconClick,
    onSearchInputActivated: onSearchInputActivated,
    searchInputClassName: searchInputClassName,
    placeholder: placeholder,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 5
    }
  }) : /*#__PURE__*/React.createElement(SCSearchIconContainer, {
    isIconHoverRequired: isIconHoverRequired,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(SearchIcon, {
    onClick: onSearchIconClick,
    "data-testid": "search-icon",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 7
    }
  }), isIconHoverRequired && /*#__PURE__*/React.createElement(SearchIconHover, {
    onClick: onSearchIconClick,
    "data-testid": "search-icon-hover",
    className: "hover",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 9
    }
  }));
};

export default Search;